import Vue from 'vue'

function TagCell (fn) {
  const TagComponent = Vue.extend({
    template: `<p class="-tag" :class="classes" v-if="text !== ''">{{text}}</p>`,
    data () {
      return {
        classes: '',
        text: ''
      }
    },
    beforeMount() {
      if (fn) {
        const { text, color } = fn(this.params)
        this.text = text
        this.classes = color
      }
    }
  })
  return TagComponent
}

export default TagCell



// WEBPACK FOOTER //
// ./src/pages/components/ag-grid/TagCell.js